import { useCallback, useEffect, useState } from "react";

export default function useOAViewMode({ preferencesEnabled, isPreferencesFetched, isLoadingPreferences, screenPreferences, savePreferences, onCalendarMode }) {
	const [viewMode, setViewMode] = useState("table");
	const [preferencesInitialized, setPreferencesInitialized] = useState(false);

	useEffect(() => {
		if (!preferencesEnabled || !isPreferencesFetched || preferencesInitialized || isLoadingPreferences) {
			return;
		}

		if (screenPreferences?.view_mode) {
			setViewMode(screenPreferences.view_mode);
		}

		setPreferencesInitialized(true);
	}, [preferencesEnabled, isPreferencesFetched, preferencesInitialized, isLoadingPreferences, screenPreferences]);

	const handleViewModeChange = useCallback(
		(newMode) => {
			setViewMode(newMode);
			savePreferences({
				viewMode: newMode,
				visibleColumns: screenPreferences?.visible_columns ?? null,
			});

			if (newMode === "calendar") {
				onCalendarMode();
			}
		},
		[onCalendarMode, savePreferences, screenPreferences],
	);

	return {
		viewMode,
		handleViewModeChange,
	};
}
